import script from "./AdminPortalView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPortalView.vue?vue&type=script&setup=true&lang=js"

import "./AdminPortalView.vue?vue&type=style&index=0&id=714d445f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714d445f"]])

export default __exports__